import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WasteCategoryComponent} from './waste-category.component';
const routes: Routes = [
  {
    path: '',
    component: WasteCategoryComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WasteCategoryRoutingModule { }
